"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERROR_ESTIMATING_GAS = exports.ERROR_REMOVING_LIQUIDITY = exports.ERROR_ADDING_LIQUIDITY = exports.ERROR_ADDING_LIQUIDITY_ETH = exports.ERROR_GETTING_PAIR = void 0;
exports.ERROR_GETTING_PAIR = 'Error getting pair';
exports.ERROR_ADDING_LIQUIDITY_ETH = 'Error adding ETH/TOKEN liquidity';
exports.ERROR_ADDING_LIQUIDITY = 'Error adding liquidity';
exports.ERROR_REMOVING_LIQUIDITY = 'Error removing liquidity';
exports.ERROR_ESTIMATING_GAS = 'Error estimating gas';
